import './QrCodeDisplay.css';

interface QrCodeDisplayProps {
  // SVG markup as returned by the API. Rendered with dangerouslySetInnerHTML
  // because rotp/rqrcode produces clean self-contained SVG; the API trusts it.
  svg?: string;
  // Fallback raw provisioning URI (otpauth://...). Surfaced as text + copy
  // button when the user can't scan.
  uri?: string;
  // Optional secret to show as fallback for manual entry.
  secret?: string;
  alt?: string;
}

export function QrCodeDisplay({ svg, uri, secret, alt = 'TOTP QR code' }: QrCodeDisplayProps) {
  return (
    <div className="qr-code-display" data-testid="qr-code-display">
      {svg ? (
        <div
          className="qr-code-display__svg"
          role="img"
          aria-label={alt}
          dangerouslySetInnerHTML={{ __html: svg }}
        />
      ) : (
        <div className="qr-code-display__placeholder" aria-hidden="true">
          QR code unavailable — use the manual key below.
        </div>
      )}

      {secret && (
        <div className="qr-code-display__manual">
          <span className="qr-code-display__manual-label">Manual key:</span>
          <code className="qr-code-display__manual-value">{secret}</code>
        </div>
      )}

      {uri && (
        <details className="qr-code-display__uri">
          <summary>Show provisioning URI</summary>
          <code>{uri}</code>
        </details>
      )}
    </div>
  );
}
